import { ServiceTypeActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { ServiceTypeFormData } from 'src/screens/General/screens/ServiceTypes/components/ServiceTypeForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';

export interface GetServiceTypesAction {
    type: typeof ServiceTypeActions.STAFF_FETCH_SERVICE_TYPES;
    payload: QueryParams;
}

export function getServiceTypes(params: QueryParams): GetServiceTypesAction {
    return {
        type: ServiceTypeActions.STAFF_FETCH_SERVICE_TYPES,
        payload: params,
    };
}

export interface GetServiceTypeAction {
    type: typeof ServiceTypeActions.STAFF_FETCH_SERVICE_TYPE;
    payload: {
        id: number | string;
    };
}

export function getServiceType(id: number | string): GetServiceTypeAction {
    return {
        type: ServiceTypeActions.STAFF_FETCH_SERVICE_TYPE,
        payload: { id },
    };
}
export interface GetOrderServiceTypesAction {
    type: typeof ServiceTypeActions.STAFF_FETCH_ORDER_SERVICE_TYPES;
    payload: {
        type: number | string;
    };
}
export function getOrderServiceTypes(type: number | string): GetOrderServiceTypesAction {
    return {
        type: ServiceTypeActions.STAFF_FETCH_ORDER_SERVICE_TYPES,
        payload: { type },
    };
}
export interface DeleteServiceTypeAction {
    type: typeof ServiceTypeActions.STAFF_DELETE_SERVICE_TYPE;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteServiceType(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteServiceTypeAction {
    return {
        type: ServiceTypeActions.STAFF_DELETE_SERVICE_TYPE,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistServiceTypeAction {
    type: typeof ServiceTypeActions.STAFF_PERSIST_SERVICE_TYPE;
    payload: {
        data: ServiceTypeFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistServiceType(data: ServiceTypeFormData, callbacks: SagaPromise<any>): PersistServiceTypeAction {
    return {
        type: ServiceTypeActions.STAFF_PERSIST_SERVICE_TYPE,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistServiceType = (data: ServiceTypeFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistServiceType(data, { resolve, reject }));
    });
};

/*export interface UpdateClaimAction {
    type: typeof ServiceTypeActions.STAFF_UPDATE_CLAIM;
    payload: {
        data: ClaimFormData;
        callbacks: SagaPromise<any>;
    };
}

export function updateClaim(data: ClaimFormData, callbacks: SagaPromise<any>): UpdateClaimAction {
    return {
        type: ServiceTypeActions.STAFF_UPDATE_CLAIM,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncUpdateClaim = (data: ClaimFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateClaim(data, { resolve, reject }));
    });
};*/

export type Actions =
    | GetServiceTypesAction
    | GetServiceTypeAction
    | DeleteServiceTypeAction
    | PersistServiceTypeAction
    | GetOrderServiceTypesAction;
